import classNames from 'clsx'

import S from './Loader.module.scss'

export type LoaderVariant = 'fullscreen' | 'inline' | 'small'

export interface LoaderProps {
  variant?: LoaderVariant
  className?: string
}

const Loader = ({ variant = 'inline', className }: LoaderProps) => {
  return (
    <div className={classNames(S.loader, S[variant], className)}>
      <div className={S.spinner} />
    </div>
  )
}

export default Loader
